import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import { CardoGroup } from '@cotyorg/ccx-organism-cardo-group';
import StandardLayout from '../../templates/StandardLayout';
import SectionHeader from '../../atoms/SectionHeader';
import ShadeFinder from '../../organisms/ShadeFinder/components/ShadeFinder';
import { vtoTypes } from '../../organisms/VtoModal/config';

export const quizBaseBreakpointConfig = {
  xsmall: {
    contentAlignment: {
      horizontal: 'middle',
      vertical: 'bottom',
    },
    gridSetup: {
      image: {
        columns: 16,
      },
      content: {
        columns: 16,
      },
      card: {
        columns: 16,
      },
    },
  },
  medium: {
    gridSetup: {
      card: {
        columns: 8,
      },
    },
  },
  large: {
    gridSetup: {
      card: {
        columns: 4,
      },
    },
  },
};

export const quizEveryNthBreakpointConfig = [{}, {}, {}];

const activeVtoTypes = [
  vtoTypes.SHADE_FINDER,
  vtoTypes.MAKEUP_FINDER,
  vtoTypes.NAIL_VTO,
];

const VirtualTryOnComponent = ({ sectionHeadings, shadeFinder, vto }) => {
  const [activeVtoType, setActiveVtoType] = useState('');

  const selectedProductSlug = R.path(
    [activeVtoType, 0, 'slug'],
    R.prop('products', vto)
  );

  return (
    <StandardLayout>
      <div className="vto-page">
        <div className="grid-container">
          <div className="grid-x grid-margin-x align-center">
            <div className="cell xsmall-16">
              <div className="vto-page__content">
                <div className="cell">
                  <OptionalSection
                    renderCondition={!!R.prop('heading')(sectionHeadings)}
                    section={() => (
                      <SectionHeader>
                        <Heading extraClass="section__title" level={1}>
                          {R.prop('heading')(sectionHeadings)}
                        </Heading>
                      </SectionHeader>
                    )}
                  />

                  <OptionalSection
                    renderCondition={
                      !!R.prop('subheading')(sectionHeadings) && !!shadeFinder
                    }
                    section={() => (
                      <Paragraph alignment="center">
                        {R.prop('subheading', sectionHeadings)}
                      </Paragraph>
                    )}
                  />

                  <OptionalSection
                    renderCondition={
                      !!R.prop('introduction')(sectionHeadings) && !!shadeFinder
                    }
                    section={() => (
                      <Paragraph
                        alignment="center"
                        extraClass="vto-page__legal"
                      >
                        {R.prop('introduction', sectionHeadings)}
                      </Paragraph>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          {shadeFinder ? (
            <div className="grid-x grid-margin-x align-center">
              <CardoGroup
                data="cards"
                contentTheme="transparent"
                baseBreakpointConfig={quizBaseBreakpointConfig}
                everyNthBreakpointConfig={quizEveryNthBreakpointConfig}
                onClick={({ cardoIndex }) => {
                  setActiveVtoType(activeVtoTypes[cardoIndex]);
                }}
                isSpanButton
              />
            </div>
          ) : (
            <div className="grid-x grid-margin-x align-center">
              <Paragraph alignment="center" extraClass="vto-page__notext">
                {R.prop('no_vto_text', sectionHeadings)}
              </Paragraph>
            </div>
          )}

          {!!shadeFinder && (
            <div className="grid-x grid-margin-x align-center">
              <div className="product-page__section-try-on">
                <ShadeFinder
                  shadeFinderConfiguration={shadeFinder}
                  isOpen={!!activeVtoType}
                  onClose={() => {
                    setActiveVtoType('');

                    if (window && window.YMK) {
                      window.YMK.closeEngine();

                      window.YMK = null;
                    }
                  }}
                  hideVtoButton
                  initialVtoType={activeVtoType}
                  vtoActualProductSlug={selectedProductSlug}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </StandardLayout>
  );
};

VirtualTryOnComponent.propTypes = {
  sectionHeadings: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
    introduction: PropTypes.string,
    no_vto_text: PropTypes.string,
  }),
  shadeFinder: PropTypes.object.isRequired,
  vto: PropTypes.object.isRequired,
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings')(content),
  shadeFinder: R.prop('shadeFinder', content),
  vto: R.prop('vto', content),
}))(VirtualTryOnComponent);
